import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeader } from "../common/apis/authHeader";
import axiosBaseURL from "../common/apis/axiosBaseURL";
import HandleError from "../common/apis/HandleError";
import { apiVersion } from "../common/apis/apiVersion";

export const ContactAsyncCall = createAsyncThunk(
    "match/ContactAsyncCall",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/contactus/create", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data;
        }
    }
);

export const GetLinkAsyncCall = createAsyncThunk(
    "match/GetLinkAsyncCall",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/contactus/create", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data;
        }
    }
);

const initialState = {
    contact_us: {},
    get_link: {}
};

const contactSlice = createSlice({
    name: "series",
    initialState,
    reducers: {
        ResetContactDetail: (state) => {
            state.contact_us = {};
        },
        ResetContGetLink: (state) => {
            state.get_link = {};
        }
    },
    extraReducers: {
        [ContactAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [ContactAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, contact_us: payload, loading: false };
        },
        [ContactAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [GetLinkAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [GetLinkAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, get_link: payload, loading: false };
        },
        [GetLinkAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        }
    }
})

export const { ResetContactDetail, ResetContGetLink } = contactSlice.actions;
export const getLoading = (state) => state.contact;
export const getContactData = (state) => state.contact.contact_us;
export const getAppLinkData = (state) => state.contact.get_link;
export default contactSlice.reducer;
